import React from 'react';
import KhyaalTechLanding from './components/KhyaalTechLanding';

function App() {
  return (
    <div className="App">
      <KhyaalTechLanding />
    </div>
  );
}

export default App;